import {AuthorizationColumn, authorizationFieldFormattedValue, AuthorizationInfo} from "../domain";
import React from "react";
import {get} from "lodash";
import {AuthorizationListColumn} from "./AuthorizationList";
import {AuthorizationListAction} from "./authorizationListReducer";
import {LinkToNewTabKeepContext} from "common";
import { useApplicationRootUrl } from "common/component/ApplicationRootContext";

type AuthorizationPreviewProps = {
    authorization: AuthorizationInfo,
    selected: boolean,
    dispatch: React.Dispatch<AuthorizationListAction>
}

export function AuthorizationPreview({authorization, selected, dispatch}: AuthorizationPreviewProps) {
    const rootUrl = useApplicationRootUrl();
    const displayColumn = (column: AuthorizationColumn) => {
        if (column.attr === 'allServiceType' && get(authorization, 'allServiceType')) {
            return <>
                {get(authorization, 'allServiceType').join(", ")}
            </>
        }

        if (column.attr === 'client.fullName' && get(authorization, 'client.fullName')) {
            return (
                <LinkToNewTabKeepContext link={`${rootUrl}/clients/${authorization?.client.guid}/contacts`}>
                        <span className={`underline ${selected ? 'text-white' : 'text-blue-portal-link'}`}>
                                {get(authorization, column.attr)}
                        </span>
                </LinkToNewTabKeepContext>
            )
        }

        if (column.attr === 'bhpnAuthNumber' && get(authorization, 'bhpnAuthNumber')) {
            return (
                <LinkToNewTabKeepContext link={`${rootUrl}/clients/${authorization?.client.guid}/authorizations?authorizationGuid=${authorization?.guid}`}>
                        <span className={`underline ${selected ? 'text-white' : 'text-blue-portal-link'}`}>
                                {get(authorization, column.attr)}
                        </span>
                </LinkToNewTabKeepContext>
            )
        }

        return (<>
            {authorizationFieldFormattedValue(authorization, column.attr)}
        </>);
    }


    return (
        <tr className={`border-b border-gray-200 relative
        hover:${selected ? 'bg-botticelli-100' : 'bg-gray-200'}
        ${selected ? 'bg-botticelli-100 text-white' : ''}
        ${authorization.isAtRisk ? 'bg-red-200 border-red-300 hover:bg-red-300' : ''}`}>
            {
                AuthorizationListColumn.map((column) => (
                    <td
                        key={column.name}
                        className={'py-5' + (column.attr === 'bhpnAuthNumber' ? ' pl-8' : '')}
                        onClick={() => dispatch({type: "SET_SELECTED", selected: authorization})}
                        colSpan={column.span}
                    >
                        {
                            displayColumn(column)
                        }
                    </td>
                ))
            }
        </tr>
    );
}
